import { createContext } from "react";

export const ApplicantMessageContext = createContext<{
  showApplicantMessages: boolean;
}>({ showApplicantMessages: false });
